import React from "react";
import LayoutContentWrapper from "../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import Buttons, { EnumButtonType, EnumColors } from "../../../components/Utils/Buttons/Buttons/Buttons";
import styles from "./DemoSuccess.module.css";
import ImageForHorizon from "../../../components/Utils/Images/ImageForHorizon/ImageForHorizon";
import imageSuccess from "../../../uploads/images/demoSuccess.jpeg";

import {useAppSelector} from "../../../hooks/redux";
import {getUser} from "../../../store/selectors/authSelector";
const DemoSuccess = () => {
	const user = useAppSelector(getUser);

	const handlerOpenDemo = () => {
		const token = localStorage.getItem("token");
		if(token && user && user.id){
			const params = new URLSearchParams({
				id: encodeURIComponent(user.id),
				token: encodeURIComponent(token as string),
			}).toString();
	
			//window.open("https://misgtg.tretyakov.ru/misdemo?"+params, "_blank")
			window.location.replace("https://misgtg.tretyakov.ru/misdemo?"+params);
		}
		
	};

	return (
		<>
			<ImageForHorizon
				blurhash={"QZHxpGxuaeWVxvV@xuxtRQyZkDaejut7WBozbHWBI]WXWAaeRjs:RjRjt6"}
				src={imageSuccess}
				alt={"Рожь, 1878. Шишкин Иван (1832-1898)."}
			/>
			<LayoutContentWrapper>
				<p>Ознакомиться с инструкцией по работе с <a href="https://misgtg.tretyakov.ru/static/media/Описание%20МИС.c410ca724b28e17b83e4.pdf">музейной информационной системой МИС</a></p>
				<Buttons className={styles.buttonOpenDemo} type={EnumButtonType.filled} color={EnumColors.gold} onClick={handlerOpenDemo}>
					Открыть демо
				</Buttons>
			</LayoutContentWrapper>
		</>
	);
};

export default DemoSuccess;
